export default __webpack_public_path__ + "static/Original-431a2a0210d748c15d590057f5cc015e.png";